import { useQueryHelpers } from '@/composables';
import warehouseService from '@satellite/services/warehouse-service';
import type { IWarehouse } from '@nova/core';
import type { IQueryArgs } from '@/types/apiTypes';

const { useSmartQuery } = useQueryHelpers();

export default function useWarehouseQueries() {
  const getListWarehousesQuery = (queryArgs?: IQueryArgs) =>
    useSmartQuery<Partial<IWarehouse>[]>(
      ['warehouses', 'list'],
      ({ params, options, signal }) =>
        warehouseService.getListWarehouses(params, options, { signal }) as Promise<
          Partial<IWarehouse>[]
        >,
      queryArgs
    );

  return { getListWarehousesQuery };
}
